import styled from "styled-components"

const BPSPrimaryButton = styled.a`
    color: #fff;
    background-color: #0478c2;
    border: 1px solid #0478c2;
    border-radius: .4rem;
    text-decoration: none;
    font-weight: 500;
    font-size: 1.1rem;
    line-height: 1.1rem;
    vertical-align: middle;
    display: inline;
    padding: .5rem 1.25rem;
    text-align: center;
    transition: .25s ease;

    &:hover {
        color: #ffffff !important;
        background-color: #1c304c !important;
        border: 1px solid #1c304c !important;
    }
`

const BPSPrimaryBtn = styled.button`
    color: #fff;
    background-color: #0478c2;
    border: 1px solid #0478c2;
    border-radius: .4rem;
    text-decoration: none;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.25rem;
    vertical-align: middle;
    display: inline;
    padding: .5rem 1.25rem;
    text-align: center;
    transition: .25s ease;

    &:hover {
        color: #ffffff !important;
        background-color: #1c304c !important;
        border: 1px solid #1c304c !important;
    }
`

const BPSSecondaryButton = styled.a`
    color: #0478c2;
    border: 1px solid #0478c2;
    border-radius: .4rem;
    text-decoration: none;
    font-weight: 500;
    font-size: 1.15rem;
    line-height: 1.25rem;
    vertical-align: middle;
    display: inline;
    padding: .5rem 1.25rem;
    text-align: center;
    transition: .25s ease;

    &:hover {
        color: #1c304c;
        border: 1px solid #1c304c !important;
    }
`

const BPSTextLink = styled.a`
    color: #0478c2;

    &:hover {
        color: #1c304c;
    }
`

const BPSArrowLink = styled.a`
    color: #0478c2;
    text-decoration: none;
    font-weight: bold;
    transition: .125s ease;
    margin-left: 0rem;

    svg {
        fill: #0478c2;
        transition: .125s ease;
    }

    &:hover {
        color: #1c304c;

        svg {
            margin-left: .5rem;
            fill: #1c304c;
            transition: .125s ease;
        }
    }
`


const Arrow = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M400-280v-400l200 200-200 200Z" /></svg>

        </>
    );
}


export { BPSPrimaryButton, BPSPrimaryBtn, BPSSecondaryButton, BPSTextLink, BPSArrowLink, Arrow }
